import { render } from "./EntityBrowser.vue?vue&type=template&id=a7061258"
import script from "./EntityBrowser.vue?vue&type=script&lang=js"
export * from "./EntityBrowser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__